import { inject } from '@angular/core';
import { Router, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { esRolSoloDonantes, RUTA_MODULADOR } from '../constants/roles';

/**
 * Guard que restringe el acceso por rol según el MER:
 * - Administrador: puede acceder a todo.
 * - Modulador: solo puede acceder a Gestión de donantes (donor-management).
 * Usa state.url (URL de destino) para no bloquear la navegación cuando el Modulador va a donor-management.
 */
export const roleGuard: CanActivateFn = (_route, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    router.navigate(['/']);
    return false;
  }

  const rol = authService.getUserRole();
  const esModulador = esRolSoloDonantes(rol);

  if (esModulador) {
    // Usar la URL de destino (state.url), no la actual, para evitar bloquear la propia navegación
    const urlDestino = state.url || '';
    const path = urlDestino.split('?')[0];
    const permiteSoloDonantes = path.includes('donor-management');

    if (!permiteSoloDonantes) {
      router.navigate([RUTA_MODULADOR]);
      return false;
    }
  }

  return true;
};
